import { EVENT_LOAD } from '../../../hooks/useTracking/events/eventTypes.js';
export const action = payload => ({
  type: EVENT_LOAD,
  payload
});
export const handler = ({
  payload
}) => (
// @ts-expect-error ...
{
  event: 'scarcity',
  event_action: payload.event_action,
  non_interaction: true
});